/*
|--------------------------------------------------------------------------
| Introduction Configuration
|--------------------------------------------------------------------------
|
*/

define('jquery', [], function () {
    "use strict";
    return window.jQuery;
});

require.config({
    baseUrl: '/js',
    "waitSeconds": 0,
    paths: {
        'config'            : 'lib/config',
        'app'               : 'lib/app',
        'helpers'           : 'lib/helpers',
        // 'jquery'            : '//ajax.googleapis.com/ajax/libs/jquery/2.1.3/jquery.min',
        'fastclick'         : '../components/fastclick/fastclick',
        'lodash'            : 'lib/custom-builds/lodash.custom',
        'domReady'          : '../components/requirejs-domready/domReady',
        'async'             : '../components/requirejs-plugins/src/async',
        'backbone'          : '../components/backbone/backbone',
        'modernizr'         : 'lib/custom-builds/modernizr.custom.34010',
        'text'              : '../components/requirejs-plugins/lib/text',
        'flexslider'        : '../components/flexslider/jquery.flexslider'
    },
    shim: {
        'modernizr': {
            exports: 'Modernizr'
        }
    },
    map: {
        '*': {
            'underscore': 'lodash'
        }
    },
    deps: ['start/app']
});
define("estate4", function(){});

